<!--  -->
<template>
  <div>
    <div class="header">
      <div class="box">
        <div class="L"><a onClick="javascript:history.back(-1)" class="goback"><img src="/static/images_m/goback.png" /></a></div>
        <div class="C"><p>直播·{{liveInfo.title}}</p></div>
      </div>
          <section class="breadcrumb-area breadcrumb-area2" :style="`background-color: #77208db8;height: 115px;background-image:url(${global.remoteIp}/uploads/${liveInfo.picsrc})`">
          <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-content">
                        <p class="breadcrumb__meta"><span class="seller-badge">{{liveInfo.spltip}}</span></p>
                        <h2 class="breadcrumb__title">{{liveInfo.title}}</h2>
                        <ul class="breadcrumb__list">
                            <li>讲师： <router-link :to="`/views/${plateid}`">{{liveInfo.teacher}}</router-link></li>
                             <li><i class="la la-globe"></i> 北京</li>
                            <li>在线人数：{{linvClient?linvClient.active:0}}</li>
                        </ul>
                    </div><!-- end breadcrumb-content -->
                </div><!-- end col-lg-12 -->
            </div><!-- end row -->
          </div><!-- end container -->
        </section>
    </div>
    <div class="clear"></div>
    <div class="hbox"></div>
     <div class="clear"></div>
    <vue-baberrage
      :isShow= "barrageIsShow"
      :barrageList = "barrageList"
      :loop = "barrageLoop"
      :style="`height: ${videoHigh};z-index: 100`"
      @dbclick="chgPlaystatus"
      >
    </vue-baberrage>
    <el-empty v-if="!isLiving" description="课程讲师暂未开播，去逛逛在线课程吧！"></el-empty>
    
    <div id="jh_live" style="width:100%; height:auto;padding: 3px;background-color: #6510AD;" ref="VideoPlay"></div>
    <div class="clear"></div>
   
      <div class="chat-content" id="chatRecord" style="overflow: auto;" updated>
          <!-- recordContent 聊天记录数组-->
          <div v-for="(itemc,indexc) in recordContent" :key="indexc">
                <!-- 对方 -->
                <div class="word" v-if="!itemc.mineMsg">
                    <img :src="itemc.headUrl">
                    <div class="info">
                          <p class="time">{{itemc.nickName}}  {{itemc.timestamp}}</p>
                          <div class="info-content">{{itemc.contactText}}</div>
                    </div>
                </div> 
                <!-- 我的 -->
                <div class="word-my" v-else>
                    <div class="info">
                          <p class="time">{{itemc.nickName}}  {{itemc.timestamp}}</p>
                          <div class="info-content">{{itemc.contactText}}</div>
                    </div>
                    <img :src="itemc.headUrl">
                </div>
            </div>
      </div>
    <el-input placeholder="请输入聊天内容" style="    position: fixed;
    bottom: 54px;z-index: 100;" v-model="msg" v-if="global.isPhone()">
                <el-button slot="append" @click="addToList()">发送</el-button>
          </el-input>
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
// import LivePlayer from '@liveqing/liveplayer'
//import VideoPlay from "../components/PublicComs/VideoPlay.vue";
// import { MESSAGE_TYPE } from 'vue-baberrage'
export default {
  data() {
    return {
      global,
      liveInfo: {},
      flvInfo: null,
      isLiving: true,
      recordContent:[],
      linvClient: {},
      msg: '',
      barrageIsShow: true,
      currentId : 0,
      barrageLoop: false,
      barrageList: [],
      videoHigh:100,
      player:{},
      timer:{}
    };
  },
  props: {
    plates: Array,
  },
  components: { },

  computed: {},
    updated(){
        // 聊天定位到底部
          let ele = document.getElementById('chatRecord');
          ele.scrollTop = ele.scrollHeight;
      },

  mounted() {
    let liveId = this.$route.params.id;
   // let liveId = "61ac6fc73ffc156948d5aa6b";
    this.$axios.get(`/api/livings/${liveId}`).then((res) => {
      if (res.data) {
        this.liveInfo = res.data.data;
        if (!this.liveInfo.addtime) {
          let addtime = this.liveInfo.createdAt;
          let date = new Date(addtime);
          this.liveInfo.addtime = `${date.getFullYear()}-${(
            "00" +
            (date.getMonth() + 1)
          ).slice(-2)}-${("00" + date.getDate()).slice(-2)} ${(
            "00" + date.getHours()
          ).slice(-2)}:${("00" + date.getMinutes()).slice(-2)}:${(
            "00" + date.getSeconds()
          ).slice(-2)}`;
        }
        if(this.liveInfo.state!==1)
        {
           this.isLiving = false;
           return;  
        }
        this.flvInfo = {
          id: this.liveInfo._id,
          url: this.global.liveIp + liveId + ".flv",
        }; 
        this.playVideo(this.global.liveIp + liveId);//".m3u8"
        this.$nextTick(function(){
          this.videoHigh = (this.$refs.VideoPlay.clientHeight - 20)/1.5 + "px";
        })
      }
    });
    this.joinLiveRoom(liveId);
    this.$axios.get("/users/"+liveId).then((res)=>{
      if (res&&res.data)
      {
        this.linvClient.active = res.data.data;
        this.$forceUpdate();
      }
    })
    this.timer =setInterval(()=>{
      this.$axios.get("/users/"+liveId).then((res)=>{
      if (res&&res.data)
      {
        this.linvClient.active = res.data.data;
        this.$forceUpdate();
      }
    })
    },1000*60);
    this.$socketBarrage.on("chatLiveRoom", (res) => {
      console.log(res)
      this.barrageList.push({
        id: ++this.currentId,
        avatar: "/static/images/avatar.png",
        msg: res.msg,
        time: 5,
        type: MESSAGE_TYPE.NORMAL,
      });
      this.recordContent.push({
        mineMsg:res.user==this.$store.getters.user.name,
        nickName:res.user,
        timestamp:this.dateFormat(new Date(),"yyyy-MM-dd hh:mm:ss"),
        headUrl:"/static/images/avatar.png",
        contactText:res.msg
      })
      this.$nextTick(() => {
       // this.$refs.barrageList.scrollTop = this.$refs.barrageList.clientHeight;
      });
    });
    window.addEventListener("keydown", this.keyDown);
    window.addEventListener('beforeunload', () =>{
      console.log("come here")
      this.leaveLiveRoom(this.liveInfo._id)
    })
  },

  beforeDestroy() {
    window.removeEventListener("keydown", this.keyDown, false);
    clearInterval(this.timer);
  },
  
  methods: {
    chgPlaystatus(){
      this.player.togglePlay();
    },
    addToList (){
      //发送弹幕
      if(!this.msg)return;
      let data = {
        room: this.liveInfo._id,
        func: "chatLiveRoom",
        data: {
          id: this.global.getCode(8),
          user: this.$store.getters.user.name,
          msg: this.msg,
        },
      };
      this.msg ="";
      this.$sockBarrage.roomChat(data);
      // this.barrageList.push({
      //   id: ++this.currentId,
      //   avatar: "/static/images/avatar.png",
      //   msg: this.msg,
      //   time: 5,
      //   type: MESSAGE_TYPE.NORMAL,
      // });
      // this.recordContent.push({
      //   mineMsg:true,
      //   nickName:this.$store.getters.user.name,
      //   timestamp:this.dateFormat(new Date(),"yyyy-MM-dd hh:mm:ss"),
      //   headUrl:"/static/images/avatar.png",
      //   contactText:this.msg
      // })
    },
    dateFormat(date, format) {
      var o = {
        "M+": date.getMonth() + 1, //month
        "d+": date.getDate(), //day
        "h+": date.getHours(), //hour 24
        "H+": date.getHours(), //hour 24
        "m+": date.getMinutes(), //minute
        "s+": date.getSeconds(), //second
        "q+": Math.floor((date.getMonth() + 3) / 3), //quarter
        S: date.getMilliseconds(), //millisecond
      };

      if (/(y+)/.test(format)) {
        format = format.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }

      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return format;
    },
    //加入直播间
    joinLiveRoom(name) {
      this.$sockBarrage.joinRoom(name);
    },

    //离开直播间
    leaveLiveRoom(name) {
      this.$sockBarrage.leaveRoom(name);
    },
    keyDown(e) {
      //如果是按回车则执行登录方法
      if (e.keyCode == 13) {
        this.addToList();
      }
    },
    playVideo(url) {
        document.getElementById('jh_live').innerHTML = ""
        this.player = new this.TcPlayer('jh_live', {
          "m3u8": url, //请替换成实际可用的播放地址
          "autoplay": true, //iOS下safari浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
          // "poster": img,
          "width": '100%', //视频的显示宽度，请尽量使用视频分辨率宽度
          "height": '100%', //视频的显示高度，请尽量使用视频分辨率高度
          "remember": 1
        });
      },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/style_Phone.scss";
::v-deep .el-divider--horizontal {
  margin-bottom: 20px;
  margin-top: 0px;
}
::v-deep .el-dialog__body {
  padding: 5px 20px 30px 20px;
}
::v-deep .el-dialog__title {
  color: #233d63;
  font-size: 29px;
  line-height: 33px;
  font-weight: 500;
}
::v-deep .el-empty__description p{
  color: #ff0000;
    font-size: 20px;
    margin: 0;
    font-weight: 600;
}
.chat-content {
  width: 100%;
  padding: 20px;
  height: 460px;
  // box-shadow: 0 2px 2px rgb(0 0 0 / 12%), 0 0 6px rgb(0 0 0 / 4%);
}
.chat-content .word {
  display: flex;
  margin-bottom: 20px;
}
.chat-content .word img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.chat-content .word .info {
  margin-left: 10px;
}
.chat-content .word .info .time {
  font-size: 12px;
  color: rgba(51, 51, 51, 0.8);
  margin: 0;
  height: 20px;
  line-height: 20px;
  margin-top: -5px;
}
.chat-content .word .info .info-content {
  padding: 10px;
  font-size: 14px;
  background: #fff;
  position: relative;
  margin-top: 8px;
}
.chat-content .word .info .info-content::before {
  position: absolute;
  left: -8px;
  top: 8px;
  content: "";
  border-right: 10px solid #fff;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
}

.word-my {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}
.word-my img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.word-my .info {
  width: 90%;
  margin-left: 10px;
  text-align: right;
}
.word-my .info .time {
  font-size: 12px;
  color: rgba(51, 51, 51, 0.8);
  margin: 0;
  height: 20px;
  line-height: 20px;
  margin-top: -5px;
  margin-right: 10px;
}
.word-my .info .info-content {
  max-width: 70%;
  padding: 10px;
  font-size: 14px;
  float: right;
  margin-right: 10px;
  position: relative;
  margin-top: 8px;
  background: #a3c3f6;
  text-align: left;
}
.word-my .info .info-content::after {
  position: absolute;
  right: -8px;
  top: 8px;
  content: "";
  border-left: 10px solid #a3c3f6;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
}
 
::-webkit-scrollbar {
  width: 14px;
  height: 14px;
}
 
::-webkit-scrollbar-track,
::-webkit-scrollbar-thumb {
  border-radius: 999px;
  border: 5px solid transparent;
}
 
::-webkit-scrollbar-track {
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2) inset;
}
 
::-webkit-scrollbar-thumb {
  min-height: 20px;
  background-clip: content-box;
  box-shadow: 0 0 0 5px rgba(0, 0, 0, 0.2) inset;
}
 
::-webkit-scrollbar-corner {
  background: transparent;
}
.container{
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  .breadcrumb-area2{
    top:45px; 
  }
  .breadcrumb-area:before{
        background-color: #6e27a9e6;
  }
a:not([href]):not([tabindex]) {
    color: initial !important;
}


  .container{
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }

  ::v-deep .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active{
    color: #6510AD;
  }
  ::v-deep .el-tabs--border-card>.el-tabs__header .el-tabs__item:not(.is-disabled):hover{
    color: #6510AD;
  }
  
 .curriculum-content .course-accordion .card {
  margin-bottom: 4px;
  border-color: rgba(127, 136, 151, 0.3);
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  border-radius: 2px;
}

 .curriculum-content .course-accordion .card:first-of-type {
  border-bottom: 1px solid rgba(127, 136, 151, 0.3);
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  border-radius: 2px;
}

 .curriculum-content .course-accordion .card:not(:first-of-type):not(:last-of-type) {
  border-bottom: 1px solid rgba(127, 136, 151, 0.3);
}

 .curriculum-content .course-accordion .card .card-header {
  padding: 0;
  text-align: left;
  background-color: #F7FAFD;
  border-bottom-color: rgba(127, 136, 151, 0.3);
}

 .curriculum-content .course-accordion .card .card-header .btn-link {
  display: block;
  width: 100%;
  text-align: left;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0;
  padding: 10px 20px 10px 35px;
  border: none;
  color: #233d63;
  text-decoration: none;
  font-size: 18px;
  position: relative;
  font-weight: 500;
}

 .curriculum-content .course-accordion .card .card-header .btn-link i.la {
  display: none;
  position: absolute;
  left: 10px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  color: #7f8897;
}

 .curriculum-content .course-accordion .card .card-header .btn-link .btn-text {
  float: right;
  color: #7f8897;
  font-size: 16px;
}

 .curriculum-content .course-accordion .card .card-header .btn-link[aria-expanded=true] i.la.la-angle-up {
  display: block;
}

 .curriculum-content .course-accordion .card .card-header .btn-link[aria-expanded=false] i.la.la-angle-down {
  display: block;
}

 .curriculum-content .course-accordion .card .card-body {
  padding: 0;
}

 .curriculum-content .course-accordion .card .card-body .card-list .card-list-item {
  position: relative;
  border-bottom: 1px solid rgba(127, 136, 151, 0.2);
  padding: 10px 20px 10px 10px;
}

@media (max-width: 375px) {
   .curriculum-content .course-accordion .card .card-body .card-list .card-list-item {
    padding-left: 10px;
  }
}

 .curriculum-content .course-accordion .card .card-body .card-list .card-list-item:last-child {
  border-bottom: 0;
}

 .curriculum-content .course-accordion .card .card-body .card-list .card-list-item .course-play__icon {
  margin-right: 5px;
}

 .curriculum-content .course-accordion .card .card-body .card-list .card-list-item .course-duration {
  position: absolute;
  right: 20px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  color:#6510AD;
}

 .curriculum-content .course-accordion .card .card-body .card-list .card-list-item .preview-link {
  background-color: transparent;
  outline: none;
  border: none;
  color: #6510AD;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}

 .curriculum-content .course-accordion .card .card-body .card-list .card-list-item .preview-link:hover {
  color: #233d63;
}

 .curriculum-content .course-accordion .card .card-body .card-list .card-list-item .modal .modal-title {
  line-height: 26px;
}

 .curriculum-content .course-accordion .card .card-body .card-list .card-list-item .modal .modal-dialog {
  max-width: 650px;
}

@media only screen and (min-width: 480px) and (max-width: 767px) {
   .curriculum-content .course-accordion .card .card-body .card-list .card-list-item .modal .modal-dialog {
    max-width: 500px;
  }
}

@media only screen and (min-width: 320px) and (max-width: 479px) {
   .curriculum-content .course-accordion .card .card-body .card-list .card-list-item .modal .modal-dialog {
    max-width: 500px;
  }
}

@media (max-width: 575px) {
   .curriculum-content .course-accordion .card .card-body .card-list .card-list-item .modal .modal-dialog {
    max-width: 100%;
  }
}
@media only screen and (min-width: 480px) and (max-width: 767px) {
  .comments-wrapper .comments-list li .comment {
    text-align: left;
  }
}

@media only screen and (min-width: 320px) and (max-width: 479px) {
  .comments-wrapper .comments-list li .comment {
    text-align: left;
  }
}
.el-tabs__content img {
  max-width: 100%;
}
.name-box{
  width: 70%;
    height: -4px;
    margin-left: 10px;
}
.name-box .name{
     font-size: 20px;
    line-height: 26px;
    color: #2B333B;
    font-weight: 700;
    margin-bottom: 0.16rem;
}
.name-box .time{
    line-height: 11px;
    font-size: 10px;
    color: #B7BBBF;
}
.meta-data{
      display: flex;
    align-items: center;
    height: 0.85333333rem;
    margin-bottom: 0.26666667rem;
    font: 14px/2em "PingFang SC","微软雅黑","Microsoft YaHei",Helvetica,"Helvetica Neue",Tahoma,Arial,sans-serif;
}

/*=============== comments-wrapper ===============*/
.comments-wrapper .comments-title,
.comments-wrapper .contact-title {
  font-size: 24px;
  font-weight: 600;
}

.comments-wrapper .comments-list {
  margin-top: 20px;
  padding-top: 10px;
  margin-bottom: 25px;
  border-top: 1px solid rgba(127, 136, 151, 0.2);
}

.comments-wrapper .comments-list li .comment {
  border-bottom: 1px solid #eee;
  margin-bottom: 10px;
  margin-top: 25px;
  /* padding-bottom: 50px; */
}


.comments-wrapper .comments-list li .comment .avatar__img {
  width: 100px;
  height: 100px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  margin-right: 20px;
  float: left;
}

@media only screen and (min-width: 480px) and (max-width: 767px) {
  .comments-wrapper .comments-list li .comment .avatar__img {
    float: none;
    margin-right: 0;
  }
}

@media only screen and (min-width: 320px) and (max-width: 479px) {
  .comments-wrapper .comments-list li .comment .avatar__img {
    float: none;
    margin-right: 0;
  }
}

.comments-wrapper .comments-list li .comment .comment-body {
  margin-left: 20px;
}

@media only screen and (min-width: 480px) and (max-width: 767px) {
  .comments-wrapper .comments-list li .comment .comment-body {
    margin-left: 0;
  }
}

@media only screen and (min-width: 320px) and (max-width: 479px) {
  .comments-wrapper .comments-list li .comment .comment-body {
    margin-left: 0;
  }
}

.comments-wrapper .comments-list li .comment .comment-body .meta-data {
  position: relative;
}

@media only screen and (min-width: 480px) and (max-width: 767px) {
  .comments-wrapper .comments-list li .comment .comment-body .meta-data {
    margin-top: 15px;
  }
}

@media only screen and (min-width: 320px) and (max-width: 479px) {
  .comments-wrapper .comments-list li .comment .comment-body .meta-data {
    margin-top: 15px;
  }
}

.comments-wrapper .comments-list li .comment .comment-body .meta-data .comment__author {
  font-size: 18px;
  text-transform: capitalize;
  color: #233d63;
  margin-bottom: 5px;
  display: inline-block;
  font-weight: 600;
}

.comments-wrapper .comments-list li .comment .comment-body .meta-data .comment__date {
  font-size: 15px;
  color: #7f8897;
}

.comments-wrapper .comments-list li .comment .comment-body .meta-data .review-stars {
  position: absolute;
  right: 10px;
  top: 10px;
}

@media only screen and (min-width: 480px) and (max-width: 767px) {
  .comments-wrapper .comments-list li .comment .comment-body .meta-data .review-stars {
    position: inherit;
    right: auto;
    top: auto;
    margin-top: 4px;
  }
}

@media only screen and (min-width: 320px) and (max-width: 479px) {
  .comments-wrapper .comments-list li .comment .comment-body .meta-data .review-stars {
    position: inherit;
    right: auto;
    top: auto;
    margin-top: 4px;
  }
}

.comments-wrapper .comments-list li .comment .comment-body .meta-data .review-stars li {
  display: inline-block;
  color: #F68A03;
}

.comments-wrapper .comments-list li .comment .comment-body .meta-data .review-stars li:nth-child(4),
.comments-wrapper .comments-list li .comment .comment-body .meta-data .review-stars li:nth-child(5) {
  color: #7f8897;
}

.comments-wrapper .comments-list li .comment .comment-body .meta-data .review-stars2 li:nth-child(4) {
  color: #F68A03;
}

.comments-wrapper .comments-list li .comment .comment-body .meta-data .review-stars3 li:nth-child(4),
.comments-wrapper .comments-list li .comment .comment-body .meta-data .review-stars3 li:nth-child(5) {
  color: #F68A03;
}

.comments-wrapper .comments-list li .comment .comment-body .comment-content {
font-size: 14px;
    color: #2B333B;
    word-wrap: break-word;
    text-align: justify;
}

@media (max-width: 600px) {
  .comments-wrapper .comments-list li .comment .comment-body .comment-content {
    margin-bottom: 20px;
  }
}

.comments-wrapper .comments-list li .comment .comment-body .comment-reply .comment__btn {
  color: #7f8897;
  position: relative;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  font-size: 16px;
  display: inline-block;
  padding: 7px 18px;
  border: 1px solid #eee;
  -webkit-border-radius: 30px;
  -moz-border-radius: 30px;
  border-radius: 30px;
  font-weight: 500;
}

.comments-wrapper .comments-list li .comment .comment-body .comment-reply .comment__btn:hover {
  background-color: #51be78;
  color: #fff;
  border-color: #51be78;
}

.comments-wrapper .comments-list li .comment .comment-body .comment-reply .helpful__action {
  float: right;
  margin-top: 10px;
}

@media only screen and (min-width: 480px) and (max-width: 767px) {
  .comments-wrapper .comments-list li .comment .comment-body .comment-reply .helpful__action {
    margin-top: 30px;
    float: none;
  }
}

@media only screen and (min-width: 320px) and (max-width: 479px) {
  .comments-wrapper .comments-list li .comment .comment-body .comment-reply .helpful__action {
    margin-top: 30px;
    float: none;
  }
}

.comments-wrapper .comments-list li .comment .comment-body .comment-reply .helpful__action a {
  border: 1px solid rgba(128, 137, 150, 0.4);
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  padding: 4px 12px;
  color: #7f8897;
  margin-left: 3px;
  margin-right: 3px;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}

.comments-wrapper .comments-list li .comment .comment-body .comment-reply .helpful__action a:hover {
  background-color: rgba(128, 137, 150, 0.1);
  color: #233d63;
}

.comments-wrapper .comments-list li .comments-reply {
  margin-left: 130px;
}

@media only screen and (min-width: 480px) and (max-width: 767px) {
  .comments-wrapper .comments-list li .comments-reply {
    margin-left: 0;
  }
}

@media only screen and (min-width: 320px) and (max-width: 479px) {
  .comments-wrapper .comments-list li .comments-reply {
    margin-left: 0;
  }
}

.comments-wrapper .see-more-review-btn {
  margin-bottom: 50px;
}

.comments-wrapper .see-more-review-btn .button-shared .theme-btn {
  line-height: 45px;
  padding-right: 20px;
  padding-left: 20px;
  font-size: 15px;
  outline: none;
}
::v-deep .el-input-group__append, .el-input-group__prepend
{
  background-color: #c1acd3;
    color: #874eb7;
    vertical-align: middle;
    display: table-cell;
    position: relative;
    border: 1px solid #c1acd3;
    border-radius: 4px;
    padding: 0 20px;
    width: 1px;
    white-space: nowrap;
    font-size: 20px;
}


/*====================================================
    breadcrumb-area
 ====================================================*/
.breadcrumb-area {
  background-color: #F7FAFD;
  height: 450px;
  display: -webkit-flex;
  display: -ms-flex;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  position: relative;
  text-align: center;
  z-index: 2;
  color: #fff;
  background-image: url("/static/images/breadcrumb-bg.jpg");
  background-size: cover;
  background-position: center;
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .breadcrumb-area {
    height: 300px;
  }
}

@media only screen and (min-width: 480px) and (max-width: 767px) {
  .breadcrumb-area {
    height: 300px;
  }
}

@media only screen and (min-width: 320px) and (max-width: 479px) {
  .breadcrumb-area {
    height: 300px;
  }
}

@media (max-width: 375px) {
  .breadcrumb-area {
    height: 220px;
  }
}

.breadcrumb-area .breadcrumb-content {
  position: relative;
  z-index: 3;
}

.breadcrumb-area .breadcrumb-content .breadcrumb__title {
  font-size: 70px;
  text-transform: capitalize;
  font-weight: 700;
  color: #fff;
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .breadcrumb-area .breadcrumb-content .breadcrumb__title {
    font-size: 50px;
  }
}

@media only screen and (min-width: 480px) and (max-width: 767px) {
  .breadcrumb-area .breadcrumb-content .breadcrumb__title {
    font-size: 50px;
  }
}

@media only screen and (min-width: 320px) and (max-width: 479px) {
  .breadcrumb-area .breadcrumb-content .breadcrumb__title {
    font-size: 40px;
  }
}

.breadcrumb-area .breadcrumb-content .breadcrumb__list {
  margin-top: 8px;
}

.breadcrumb-area .breadcrumb-content .breadcrumb__list li {
  display: inline-block;
  text-transform: capitalize;
  color: #F7FAFD;
  font-size: 16px;
  font-weight: 500;
  position: relative;
  padding-right: 22px;
}

.breadcrumb-area .breadcrumb-content .breadcrumb__list li:last-child {
  padding-right: 0;
}

.breadcrumb-area .breadcrumb-content .breadcrumb__list li a {
  color: #F7FAFD;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}

.breadcrumb-area .breadcrumb-content .breadcrumb__list li a:hover {
  color: #51be78;
}

.breadcrumb-area .breadcrumb-content .breadcrumb__list li.active__list-item:after {
  position: absolute;
  content: '.';
  top: -6px;
  right: 0;
  padding: 0 6px;
  font-size: 20px;
}

.breadcrumb-area .breadcrumb-content .text-outline {
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: rgba(255, 255, 255, 0.1);
  -ms-text-stroke-color: rgba(255, 255, 255, 0.1);
  -o-text-stroke-color: rgba(255, 255, 255, 0.1);
  font-size: 140px;
  color: transparent;
  position: absolute;
  letter-spacing: -0.02em;
  bottom: -115px;
  left: 0;
  right: 0;
  z-index: -1;
  text-transform: capitalize;
  font-weight: 600;
}

@media (max-width: 1199px) {
  .breadcrumb-area .breadcrumb-content .text-outline {
    display: none;
  }
}

.breadcrumb-area:before {
  position: absolute;
  content: '';
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #233d63;
  opacity: 0.9;
  z-index: -1;
}


/*====================================================
    breadcrumb-area 2
 ====================================================*/
.breadcrumb-area2 {
  text-align: left;
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .breadcrumb-area2 {
    height: 450px;
  }
}

@media only screen and (min-width: 480px) and (max-width: 767px) {
  .breadcrumb-area2 {
    height: 450px;
  }
}

@media only screen and (min-width: 320px) and (max-width: 479px) {
  .breadcrumb-area2 {
    height: 450px;
  }
}

.breadcrumb-area2 .breadcrumb-content {
  padding-right: 400px;
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .breadcrumb-area2 .breadcrumb-content {
    padding-right: 0;
  }
}

@media only screen and (min-width: 480px) and (max-width: 767px) {
  .breadcrumb-area2 .breadcrumb-content {
    padding-right: 0;
  }
}

@media only screen and (min-width: 320px) and (max-width: 479px) {
  .breadcrumb-area2 .breadcrumb-content {
    padding-right: 0;
  }
}

.breadcrumb-area2 .breadcrumb-content .breadcrumb__meta {
  margin-bottom: 5px;
}

.breadcrumb-area2 .breadcrumb-content .breadcrumb__meta .seller-badge {
  background-color: #51be78;
  color: #fff;
  text-transform: uppercase;
  font-weight: 600;
  display: inline-block;
  padding: 4px 10px 4px 12px;
  -webkit-border-radius: 4px 4px 0 4px;
  -moz-border-radius: 4px 4px 0 4px;
  border-radius: 4px 4px 0 4px;
  font-size: 12px;
  position: relative;
}

.breadcrumb-area2 .breadcrumb-content .breadcrumb__meta .seller-badge:after {
  content: "";
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  top: 0;
  left: 6px;
  z-index: -1;
  background-color: #51be78;
  -webkit-transform-origin: bottom left;
  transform-origin: bottom left;
  -webkit-transform: skew(12deg, 0deg);
  -moz-transform: skew(12deg, 0deg);
  -ms-transform: skew(12deg, 0deg);
  -o-transform: skew(12deg, 0deg);
  transform: skew(12deg, 0deg);
  -webkit-border-radius: 4px 4px 0 4px;
  -moz-border-radius: 4px 4px 0 4px;
  border-radius: 4px 4px 0 4px;
}

.breadcrumb-area2 .breadcrumb-content .breadcrumb__title {
  font-size: 50px;
  text-transform: inherit;
  line-height: 58px;
}

@media (max-width: 575px) {
  .breadcrumb-area2 .breadcrumb-content .breadcrumb__title {
    font-size: 40px;
    line-height: 50px;
  }
}

.breadcrumb-area2 .breadcrumb-content .breadcrumb__list {
  margin-top: 20px;
}

.breadcrumb-area2 .breadcrumb-content .breadcrumb__list li {
  text-transform: inherit;
  padding-right: 10px;
  padding-bottom: 5px;
}

.breadcrumb-area2 .breadcrumb-content .breadcrumb__list li:last-child {
  padding-bottom: 0;
}

.breadcrumb-area2 .breadcrumb-content .breadcrumb__list li i.la {
  color: #F68A03;
}

.breadcrumb-area2 .breadcrumb-content .breadcrumb__list li i.la-globe {
  color: #fff;
}
  .breadcrumb-area2{
    top:45px; 
  }
  .breadcrumb-area:before{
        background-color: #6e27a9e6;
  }
</style>
